import { Filter, FilterType } from 'common/repositories/common.model';
import { Button } from 'components/elements';
import useFilterHandleComponent from 'hooks/filter/use-filter-handle-component';
import useFilterHandleParent from 'hooks/filter/use-filter-handle-parent';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import styles from 'styles/Filter.module.css';

import FilterContent from './filter-content';

export interface DefaultFilterControlInputProps {
  filter: Filter;
  onRequestClose: () => void;
}

export function isEmpty(value: any): boolean {
  return value === undefined || value === null || value === '';
}

export default function DefaultFilterControlInput(
  props: DefaultFilterControlInputProps,
) {
  const { filter, onRequestClose } = props;

  const initialValue = React.useMemo(() => {
    const value = filter?.value || filter?.default;
    if (filter.type === FilterType.Date) {
      return value ? new Date(value).toISOString() : undefined;
    }
    return value;
  }, [filter?.default, filter.type, filter?.value]);

  const [value, setValue] = React.useState<string | undefined>(initialValue);

  const { t } = useTranslation();

  const onSelected = React.useCallback((value: string | undefined) => {
    setValue(value ? String(value) : '');
  }, []);

  const parentFilterHandler = useFilterHandleParent();
  const filterComponentHandler = useFilterHandleComponent();

  const onSubmit = React.useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      onRequestClose();
      if (value === null) return;

      parentFilterHandler.onChangeFilters(
        filterComponentHandler.filters.map((f) => {
          if (f.name === filter.name) {
            return {
              ...f,
              value,
            };
          }
          return f;
        }),
      );
    },
    [
      filter.name,
      filterComponentHandler.filters,
      onRequestClose,
      parentFilterHandler,
      value,
    ],
  );

  return (
    <form onSubmit={onSubmit} className={styles.form}>
      <div className={styles.formContent}>
        <FilterContent filter={filter} onSelected={onSelected} value={value} />
      </div>
      <div style={applyButtonStyle}>
        <Button disabled={isEmpty(value)} type="submit">
          {t('common:apply')}
        </Button>
      </div>
    </form>
  );
}

const applyButtonStyle: React.CSSProperties = {
  padding: 8,
  display: 'flex',
  flexDirection: 'column',
};
